import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["caution", "select", "input"]

  connect() {
    this.checkOverseas()
  }

  checkOverseas() {
    if (this.hasSelectTarget) {
      const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]
      if (selectedOption && selectedOption.text === "海外") {
        this.cautionTarget.classList.add("is-display")
      } else {
        this.cautionTarget.classList.remove("is-display")
      }
    }

    if (this.hasInputTarget) {
      const value = this.inputTarget.value || ""
      if (value.includes("海外")) {
        this.cautionTarget.classList.add("is-display")
      } else {
        this.cautionTarget.classList.remove("is-display")
      }
    }
  }
}
